import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import {
  ColumnChooserService,
  FilterService,
  GridComponent,
  GridModule,
  PageService,
  ResizeService,
  SortService,
} from '@syncfusion/ej2-angular-grids';
import {
  DataStateChangeEventArgs,
  TextWrapSettingsModel,
} from '@syncfusion/ej2-grids';

import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';

import {
  NgbCalendar,
  NgbDateParserFormatter,
  NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { Get271Logs } from 'src/app/service/eligibility-log.service';
import { WhereCondition } from '../client-parent/client-parent.model';
import { ApplyFilter271, ColumnChangeBO, FilterLogsBo, GetEligibility271, GetEligibilityLogsBo } from './eligibility-logs-model';
import { columnWidth } from '../employee/employee.model';
import { DateFormatService } from 'src/app/service/dateformat.service';
import { CommonApiService } from 'src/app/service/commonapiservice';


@Component({
  selector: 'app-eligibility-logs',
  templateUrl: './eligibility-logs.component.html',
  styleUrls: ['./eligibility-logs.component.scss'],
 
})
export class EligibilityLogsComponent implements OnInit {
  ErrorDataList: any = [];
  RequestPayload: any = [];
  EligibilityListIds: any = [];
  RequestContent: any = [];
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridEligibilityLogs') public gridEligibilityLogs: GridComponent;
  @ViewChild('gridEligibility271') public gridEligibility271: GridComponent;
  public GridDataList: Observable<DataStateChangeEventArgs>;
  public GridData271: Observable<DataStateChangeEventArgs>;
  EligibilityData: any = [];
  Eligibility271Data: any = [];
  id: string = '00000000-0000-0000-0000-000000000000';
  FilterDates: FilterLogsBo = new FilterLogsBo();
  Filter271: ApplyFilter271 = new ApplyFilter271();
  type: string = '';
  conditionlist: WhereCondition[] = [];
  arraycol: any = [];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  public filterSettings: object;
  public formatOptions: Object;
  initialPage: object;
  ValidationDate: any;
  public wrapSettings: TextWrapSettingsModel;
  ErrorinitialPage: object;
  ColumnsCglogs: columnWidth[];
  eligibilityLogsError: string;
  view271client: boolean = false;
  todayDate:any="";
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  EligibilityLogsBo: GetEligibilityLogsBo = new GetEligibilityLogsBo();
  Eligibility271Logs: GetEligibility271 = new GetEligibility271();
  constructor(
    public  calendar :NgbCalendar,
    public CommonAPI: CommonApiService,
    private cdr: ChangeDetectorRef,
    private datepipe: DatePipe,
    public toasterService: ToastrService,
    public global: GlobalComponent,
    public Eligibility271: Get271Logs
  ) {
    this.GridDataList = CommonAPI;
    // this.GridData271 = Eligibility271;
  }
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    if (
      this.global.globalAgencyId == null ||
      this.global.globalAgencyId == '' ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == 0
    ) {
      return;
    }
    this.todayDate = this.calendar.getToday();
    this.formatOptions = { type: 'datetime', format: 'MM/dd/yyyy h:mm:ss a' };
    this.filterSettings = { type: 'Menu' };
    this.ErrorinitialPage = { pageSize: 10 };
    this.wrapSettings = { wrapMode: 'Content' };
    let CGPage = 250;
    this.initialPage = {
      currentPage: 1,
      pageSizes: ['10', '15', '20', '50', '100', '250'],
      pageSize: CGPage,
    };
    this.EligibilityLogsBo.pageitem = CGPage;
    this.Eligibility271Logs.pageitem = CGPage;
  }
  //...................................................onActionComplete........................................................
  public onActionComplete(args) {
    if (args.requestType == 'columnstate') {
      let hidearr = [];
      let showarr = [];
      this.gridEligibilityLogs.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != 'Actions' &&
          element.headerText != ''
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != 'Actions' &&
          element.headerText != ''
        ) {
          showarr.push(element.headerText);
        }
      });
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Eligibility_Logs.ShowColumns.forEach((old) => {
            showarr.forEach((element) => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].Eligibility_Logs.HideColumns.forEach((old) => {
            hidearr.forEach((element) => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (
            this.arraycol[0].Eligibility_Logs.ShowColumns.length != count1 ||
            this.arraycol[0].Eligibility_Logs.HideColumns.length != count
          ) {
            this.arraycol[0].Eligibility_Logs.ShowColumns = showarr;
            this.arraycol[0].Eligibility_Logs.HideColumns = hidearr;
          }
        }
      }
    }
    this.EligibilityLogsBo.currentpageno =
      this.gridEligibilityLogs.pagerModule.pagerObj.currentPage;
    this.EligibilityLogsBo.pageitem =
      this.gridEligibilityLogs.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === 'filtering' && args.action === 'filter') {
      args.columns.forEach((element) => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == 'actionBegin' && args.requestType == 'filterbeforeopen') {
      this.EligibilityLogsBo.type = args.columnType;
    }
  }
  //................................................... dataStateChange.................................................
  public dataStateChange(state): void {
    this.type = state.action.requestType.toString();
    if (this.type != 'filterchoicerequest') {
      if ((state.sorted || []).length) {
        this.EligibilityLogsBo.orderColumn = state.sorted[0].name;
        this.EligibilityLogsBo.orderType =
          state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == 'filtering' && state.action.action != 'clearFilter') {
      this.EligibilityLogsBo.field = state.action.currentFilterObject.field;
      this.EligibilityLogsBo.matchCase =
        state.action.currentFilterObject.matchCase;
      this.EligibilityLogsBo.operator =
        state.action.currentFilterObject.operator;
      this.EligibilityLogsBo.value = state.action.currentFilterObject.value;
      if (this.EligibilityLogsBo.type == 'number') {
        this.EligibilityLogsBo.value =
          state.action.currentFilterObject.value.toString();
        this.EligibilityLogsBo.field = state.action.currentFilterObject.field;
      } else if (this.EligibilityLogsBo.type == 'datetime') {
        this.EligibilityLogsBo.value = this.global.getDateTimeString(
          state.action.currentFilterObject.value
        );
        this.EligibilityLogsBo.field = state.action.currentFilterObject.field;
      } else {
        this.EligibilityLogsBo.value = state.action.currentFilterObject.value;
        this.EligibilityLogsBo.field = state.action.currentFilterObject.field;
      }
      this.EligibilityLogsBo.matchCase =
        state.action.currentFilterObject.matchCase;
      this.EligibilityLogsBo.operator =
        state.action.currentFilterObject.operator;
    } else {
      if (this.type == 'filtering' && state.action.action == 'clearFilter') {
        this.EligibilityLogsBo.field = 'companyName';
        this.EligibilityLogsBo.matchCase = false;
        this.EligibilityLogsBo.operator = 'startswith';
        this.EligibilityLogsBo.value = '';
        this.EligibilityLogsBo.type = 'string';
      }
    }
    if (this.type != 'refresh') {
      this.ApplyFilter();
    }
    if (this.type == 'paging' && state.action.name == 'actionBegin') {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Eligibility_Logs.Pagesize != state.take) {
          this.arraycol[0].Eligibility_Logs.Pagesize = state.take;
        }
      }
    }
  }
  //.............................................onResize.................................................................
  onResize(args) {
    if (this.ColumnsCglogs != undefined && this.ColumnsCglogs != null) {
      const column = this.gridEligibilityLogs.getColumnByField(
        args.column.field
      );
      column.width = args.column.width;
      this.gridEligibilityLogs.refreshHeader();
      this.ColumnsCglogs.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
    }
  }
  //...................................................onActionComplete........................................................
  public onActionComplete271(args) {
    if (args.requestType == 'columnstate') {
      let hidearr = [];
      let showarr = [];
      this.gridEligibility271.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != 'Actions' &&
          element.headerText != ''
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != 'Actions' &&
          element.headerText != ''
        ) {
          showarr.push(element.headerText);
        }
      });
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Eligibility_Logs.ShowColumns.forEach((old) => {
            showarr.forEach((element) => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].Eligibility_Logs.HideColumns.forEach((old) => {
            hidearr.forEach((element) => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (
            this.arraycol[0].Eligibility_Logs.ShowColumns.length != count1 ||
            this.arraycol[0].Eligibility_Logs.HideColumns.length != count
          ) {
            this.arraycol[0].Eligibility_Logs.ShowColumns = showarr;
            this.arraycol[0].Eligibility_Logs.HideColumns = hidearr;
          }
        }
      }
    }
    this.Eligibility271Logs.currentpageno =
      this.gridEligibility271.pagerModule.pagerObj.currentPage;
    this.Eligibility271Logs.pageitem =
      this.gridEligibility271.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === 'filtering' && args.action === 'filter') {
      args.columns.forEach((element) => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == 'actionBegin' && args.requestType == 'filterbeforeopen') {
      this.Eligibility271Logs.type = args.columnType;
    }
  }
  //................................................... dataStateChange.................................................
  public dataStateChange271(state): void {
    this.type = state.action.requestType.toString();
    if (this.type != 'filterchoicerequest') {
      if ((state.sorted || []).length) {
        this.Eligibility271Logs.orderColumn = state.sorted[0].name;
        this.Eligibility271Logs.orderType =
          state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == 'filtering' && state.action.action != 'clearFilter') {
      this.Eligibility271Logs.field = state.action.currentFilterObject.field;
      this.Eligibility271Logs.matchCase =
        state.action.currentFilterObject.matchCase;
      this.Eligibility271Logs.operator =
        state.action.currentFilterObject.operator;
      this.Eligibility271Logs.value = state.action.currentFilterObject.value;
      if (this.Eligibility271Logs.type == 'number') {
        this.Eligibility271Logs.value =
          state.action.currentFilterObject.value.toString();
        this.Eligibility271Logs.field = state.action.currentFilterObject.field;
      } else if (this.Eligibility271Logs.type == 'datetime') {
        this.Eligibility271Logs.value = this.global.getDateTimeString(
          state.action.currentFilterObject.value
        );
        this.Eligibility271Logs.field = state.action.currentFilterObject.field;
      } else {
        this.Eligibility271Logs.value = state.action.currentFilterObject.value;
        this.Eligibility271Logs.field = state.action.currentFilterObject.field;
      }
      this.Eligibility271Logs.matchCase =
        state.action.currentFilterObject.matchCase;
      this.Eligibility271Logs.operator =
        state.action.currentFilterObject.operator;
    } else {
      if (this.type == 'filtering' && state.action.action == 'clearFilter') {
        this.Eligibility271Logs.field = 'companyName';
        this.Eligibility271Logs.matchCase = false;
        this.Eligibility271Logs.operator = 'startswith';
        this.Eligibility271Logs.value = '';
        this.Eligibility271Logs.type = 'string';
      }
    }
    if (this.type != 'refresh') {
      this.ApplyFilter271();
    }
    if (this.type == 'paging' && state.action.name == 'actionBegin') {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Eligibility_Logs.Pagesize != state.take) {
          this.arraycol[0].Eligibility_Logs.Pagesize = state.take;
        }
      }
    }
  }
  //.............................................onResize.................................................................
  onResize271(args) {
    if (this.ColumnsCglogs != undefined && this.ColumnsCglogs != null) {
      const column = this.gridEligibility271.getColumnByField(
        args.column.field
      );
      column.width = args.column.width;
      this.gridEligibility271.refreshHeader();
      this.ColumnsCglogs.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
    }
  }
  //..........................................getEligibilityLogsFilter.....................................................
  getEligibilityLogsFilter() {
    let count = 0;
    let url = 'api/SFTPDetail/GetSFTP_270Logs';
    let responseData = {
      result: 'result',
      count: 'count',
    };
    this.CommonAPI.outputValues(url, this.EligibilityLogsBo, responseData, '');
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.EligibilityData = data.result;
        count = count + 1;
        if (this.global.globalAgencyId != 0) {
          if (data != null && data != undefined && count == 1) {
          }
        }
        if (this.global.globalAgencyId != 0) {
          if (data != null && data.result.length > 15) {
            this.gridEligibilityLogs.height = '500';
          } else {
            this.gridEligibilityLogs.height = 'auto';
          }
        }
      }
    );
  }
  // getEligibility271Logs() {
  //   let count = 0;
  //   let url = "api/SFTPDetail/GetSFTP_271Logs"
  //   let responseData =
  //   {
  //     result: "result",
  //     count: "count",
  //   }
  //   this.Eligibility271.outputValues(this.Eligibility271Logs);
  //   this.GridData271.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.Eligibility271Data = data.result;
  //     count = count + 1;
  //     if (this.global.globalAgencyId != 0) {
  //       if (data != null && data != undefined && count == 1) {
  //       }
  //     }
  //     if (this.global.globalAgencyId != 0) {
  //       if (data != null && data.result.length > 15) {
  //         this.gridEligibility271.height = '500';
  //       }
  //       else {
  //         this.gridEligibility271.height = 'auto';
  //       }
  //     }
  //   })
  // }

  getEligibility271Logs() {
    let url = 'api/SFTPDetail/GetSFTP_271Logs';
    let responseData = {
      result: 'result',
      count: 'count',
    };
    this.CommonAPI.outputValues(url, this.Eligibility271Logs, responseData, '');
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        if (data?.result?.length > 15) {
          this.Eligibility271Data.height = '500';
        } else {
          this.Eligibility271Data.height = 'auto';
        }
        if (data != null && data != undefined) {
          // this.getColumnwidth();
        }
      }
    );
  }
  //..................................................showorhidecolumns...........................................
  showorhidecolumns() {
    this.gridEligibilityLogs.openColumnChooser(200, 50);
  }
  showorhidecolumns271() {
    this.gridEligibility271.openColumnChooser(200, 50);
  }
  //..................................................ApplyFilter...........................................
  ApplyFilter() {
    this.EligibilityLogsBo.edi_Status =
      this.FilterDates.edi_Status != '' ? this.FilterDates.edi_Status : null;
    this.EligibilityLogsBo.transaction_Status =
      this.FilterDates.transaction_Status != ''
        ? this.FilterDates.transaction_Status
        : null;
    let fsd =
      this.FilterDates.FromDate != null &&
      this.FilterDates.FromDate != undefined &&
      this.FilterDates.FromDate != ''
        ? this.global.formatDate(this.FilterDates.FromDate)
        : '';
    let fed =
      this.FilterDates.ToDate != null &&
      this.FilterDates.ToDate != undefined &&
      this.FilterDates.ToDate != ''
        ? this.global.formatDate(this.FilterDates.ToDate)
        : '';
    if (!this.global.checkDateValidation(fsd, fed, 365, '1 year')) {
      this.FilterDates.ToDate = null;
      return;
    }
    this.EligibilityLogsBo.startDate = this.global.getDateTimeString(fsd);
    this.EligibilityLogsBo.endDate = this.global.getDateTimeString(fed);
    this.getEligibilityLogsFilter();
  }
  ApplyFilter271() {
    let fsd =
      this.Filter271.FromDate != null &&
      this.Filter271.FromDate != undefined &&
      this.Filter271.FromDate != ''
        ? this.global.formatDate(this.Filter271.FromDate)
        : '';
    let fed =
      this.Filter271.ToDate != null &&
      this.Filter271.ToDate != undefined &&
      this.Filter271.ToDate != ''
        ? this.global.formatDate(this.Filter271.ToDate)
        : '';
    if (!this.global.checkDateValidation(fsd, fed, 365, '1 year')) {
      this.Filter271.ToDate = null;
      return;
    }
    this.Eligibility271Logs.startDate = this.global.getDateTimeString(fsd);
    this.Eligibility271Logs.endDate = this.global.getDateTimeString(fed);
    this.Eligibility271Logs.edi_Status =
      this.Filter271.edi_Status != '' ? this.Filter271.edi_Status : null;
    this.Eligibility271Logs.transaction_Status =
      this.Filter271.transaction_Status != ''
        ? this.Filter271.transaction_Status
        : null;
    this.getEligibility271Logs();
  }

  getError(data) {
    this.eligibilityLogsError = data;
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
